import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { CategoryClickedEventSchema } from '../../schemas/category/CategoryClickedEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { BUSINESS_VERTICAL, EVENT_CATEGORY } from '../../constants/EventHelper'

type CategoryClickSpecificParams = Pick<
  CategoryClickEventParams,
  'CATEGORY_NAME' | 'CATEGORY_LEVEL' | 'STORE_ID_SAP' | 'STORE_ID_DBP'
>

export interface CategoryClickEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  CATEGORY_NAME: string
  CATEGORY_LEVEL: number
  STORE_ID_SAP: string
  STORE_ID_DBP: string
}

export class CategoryClickedEvent extends AnalyticsEvent {
  constructor(params: CategoryClickEventParams) {
    super(CategoryClickedEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackCategoryClickedEvent(
  categoryClickParams: CategoryClickSpecificParams
) {
  try {
    const { isEnabled = false } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_SIX) || {}
    if (isEnabled) {
      const commonProperties = getCommonParams()
      const params: CategoryClickEventParams = {
        ...commonProperties,
        ...categoryClickParams,
        BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
        EVENT_CATEGORY: EVENT_CATEGORY.GROCERY
      }
      new CategoryClickedEvent(params).track()
    }
  } catch (error) {
    console.error('Error tracking Category Clicked Event:', error)
  }
}
